import React, { Component } from "react";

class CaregiverUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <path
          className="svg"
          d="M11.3,22.9c-0.5,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.7-1.5c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.7-1-0.7-1.6
	c-0.5,0-1-0.2-1.3-0.6C5.3,17.7,5,17.2,5,16.7c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.7-1.5c0-0.2,0-0.4,0.1-0.6
	c-0.8-0.6-1.6-1.5-2.2-2.5C0.3,10.5,0,9.4,0,8.2c0-4,3.2-7.2,7.2-7.2c1.8,0,3.5,0.7,4.8,1.9c1.3-1.2,3-1.9,4.8-1.9
	c3.8,0,7,3.1,7.2,7.1c0.1,1.2-0.2,3.6-1.6,4.6c-0.2,0.2-0.5,0.3-0.9,0.3c0,0.5-0.2,1.1-0.6,1.5l-0.3,0.3c-0.3,0.3-0.7,0.5-1.1,0.5
	c0,0,0,0,0,0c0,0.5-0.2,1-0.6,1.3l-0.3,0.3c-0.3,0.3-0.8,0.5-1.3,0.5c0,0.5-0.2,0.9-0.6,1.2l-0.3,0.3c-0.4,0.4-1,0.6-1.6,0.5
	c-0.1,0.4-0.3,0.8-0.5,1.1l-1.5,1.6C12.4,22.7,11.9,22.9,11.3,22.9C11.3,22.9,11.3,22.9,11.3,22.9z M10.7,20.2
	c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.2,0.1,0.4,0.3,0.6c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.3l1.5-1.6c0.2-0.2,0.2-0.4,0.2-0.6
	c0-0.2-0.1-0.4-0.3-0.6c-0.2-0.2-0.4-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.3l0,0l0,0L10.7,20.2z M8.4,18.3c-0.2,0.3-0.1,0.8,0.1,1.1
	c0.3,0.3,0.9,0.3,1.2,0l1.5-1.6c0,0,0,0,0,0c0.3-0.3,0.3-0.9,0-1.2c-0.3-0.3-0.7-0.3-1-0.2c0,0-0.1,0.1-0.1,0.1l-1.5,1.6
	C8.6,18.2,8.5,18.2,8.4,18.3z M14.6,18.2C14.6,18.2,14.6,18.2,14.6,18.2c0.3,0.3,0.7,0.3,1,0l0.3-0.3c0.3-0.2,0.3-0.7,0-0.9
	l-4.3-4.4c-0.2-0.2-0.2-0.6,0-0.9c0.2-0.2,0.6-0.2,0.9,0l4.3,4.4c0,0,0,0,0,0c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2
	l0.3-0.3c0.1-0.1,0.2-0.3,0.2-0.5c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.2l-4.3-4.4c-0.2-0.2-0.2-0.6,0-0.9
	c0.2-0.2,0.6-0.2,0.9,0l4.3,4.3c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0.1,0.1c0.2,0.1,0.5,0.1,0.7-0.1l0.3-0.3c0.3-0.2,0.3-0.7,0-0.9
	c0,0,0,0,0,0l-5.7-6l-2.3,2.1c-1.8,1.5-3.6,1.5-5.2,0C6.8,8.8,6.7,8.6,6.7,8.4c0-0.2,0.1-0.3,0.2-0.5c1.6-1.5,3.2-3,4.2-4.1
	c-1.1-1-2.5-1.5-4-1.5C3.9,2.3,1.2,5,1.2,8.2c0,0.9,0.2,1.8,0.6,2.7c0.4,0.8,1.1,1.5,1.7,2L5,11.5c0.4-0.4,0.9-0.6,1.5-0.7
	c0.6,0,1.1,0.2,1.5,0.6l0,0c0.4,0.4,0.6,0.9,0.7,1.5c0.6,0,1.1,0.2,1.5,0.6c0.4,0.4,0.7,1,0.7,1.6c0.5,0,1,0.2,1.3,0.6
	c0.4,0.4,0.6,0.9,0.7,1.5c0.6,0,1.1,0.2,1.5,0.6C14.4,17.8,14.5,18,14.6,18.2z M6.5,16c-0.3,0.3-0.3,0.9,0,1.2
	c0.3,0.3,0.7,0.3,1,0.1c0,0,0.1-0.1,0.1-0.1l1.5-1.6c0,0,0,0,0,0c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.3,0.1-0.8-0.1-1.1
	c-0.3-0.3-0.9-0.3-1.2,0L6.5,16z M6.5,12.1C6.5,12.1,6.5,12.1,6.5,12.1c-0.3,0-0.5,0.1-0.6,0.3L4.4,14c-0.2,0.2-0.2,0.4-0.2,0.6
	c0,0.2,0.1,0.4,0.3,0.6c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.3l1.5-1.6l0,0c0.2-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.3-0.6
	c0,0,0,0,0,0C6.9,12.2,6.7,12.1,6.5,12.1z M20.9,11.8c0.4,0.2,0.7,0,0.8-0.1c0.7-0.5,1.1-2.2,1.1-3.5c-0.2-3.4-2.7-6-5.9-6
	c-1.6,0-3.2,0.7-4.3,1.8c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0c-1,1.1-2.5,2.5-4.1,4.1c0.9,0.6,1.9,0.5,3-0.4L14,5.4
	c0.3-0.2,0.6-0.2,0.9,0L20.9,11.8z"
        />
      </svg>
    );
  }
}

export default CaregiverUpSVG;



// WEBPACK FOOTER //
// ./src/svg/CaregiverUpSVG.jsx